// Migrated from transition-web/src/components/SignInEnterCode.tsx
// Updated to use new design system with split-screen layout

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { SignInViewProps } from '../../../pure-js/types/SignInTypes'
import { Button, Input } from '../interaxDesignSystemComponents'
import SignInLayout from './SignInLayout'
import { TESTIDS } from '../config/testids'

export default function SignInEnterCode(props: SignInViewProps) {
  const { /* signInState, onPressContinue, */ onClickBack /* isLoading */ } = props
  const navigate = useNavigate()

  return (
    <SignInLayout backgroundImage="/assets/img/background_login.png">
      <Box className="space-y-8">
        {/* Back Button */}
        <Box className="flex justify-start">
          <Button
            variant="link"
            onClick={onClickBack || (() => navigate('/login'))}
            className="text-thunder-grey hover:text-white"
          >
            ← Back
          </Button>
        </Box>

        {/* Header */}
        <Box className="text-center">
          <h1 className="text-4xl font-bold text-white mb-4">Welcome to Intraction</h1>
          <p className="text-thunder-grey text-lg leading-relaxed">Enter the code sent to your email below</p>
        </Box>

        {/* Code Input Form */}
        <Box className="bg-off-black border border-thunder-grey rounded-lg p-6 space-y-6">
          <SignInEnterCodeForm {...props} />
        </Box>
      </Box>
    </SignInLayout>
  )
}

// Simple form component for now - TODO: Implement proper form validation
function SignInEnterCodeForm(props: SignInViewProps) {
  const { signInState, onPressContinue, isLoading } = props
  const [code, setCode] = React.useState('')
  const [error, setError] = React.useState('')

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault()
    if (code.length !== 6) {
      setError('Please enter a 6-digit code')
      return
    }
    setError('')

    try {
      await onPressContinue({ ...signInState, data: { ...signInState.data, code } })
    } catch (err: unknown) {
      // Handle authentication errors
      const message = err instanceof Error ? err.message : String(err)
      if (message?.includes('invalid') || message?.includes('code') || message?.includes('verification')) {
        setError('Invalid verification code. Please try again.')
      } else if (message?.includes('expired')) {
        setError('Verification code has expired. Please request a new one.')
      } else {
        setError('Verification failed. Please try again.')
      }
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Box>
        <Input
          value={code}
          onChange={(e) => {
            setCode(e.target.value.replace(/\D/g, '').slice(0, 6))
            setError('')
          }}
          onEnterPress={handleSubmit}
          placeholder="000000"
          type="text"
          disabled={isLoading}
          required
          error={!!error}
          errorMessage={error}
          fullWidth
          size="large"
          className="w-full text-center text-2xl tracking-widest"
          maxLength={6}
          autoFocus
          data-testid={TESTIDS.AUTH_CODE_INPUT}
        />
      </Box>

      <Button
        variant="primary"
        fullWidth
        onClick={() => handleSubmit()}
        disabled={isLoading || code.length !== 6}
        className="h-12"
        data-testid={TESTIDS.AUTH_CODE_VERIFY_BTN}
      >
        {isLoading ? 'Verifying...' : 'Verify Code'}
      </Button>
    </form>
  )
}
